import React, { useContext } from 'react';
import styled from 'styled-components';
import ThemeContext from '../../contexts/ThemeContext';

const StyledErrorText = styled.span`
  color: ${({ $colors }) => $colors.errorColor};
  font-size: 12px;
  margin-top: 4px;
`;

export const ErrorText = ({ colors: _, ...props }) => {
  const { colors } = useContext(ThemeContext);
  return <StyledErrorText $colors={colors} {...props} />;
};
